import { useState, useCallback } from "react";
import toast from "react-hot-toast";
import { getInitials } from "../utils/stringUtils";
import { dedupeFetch } from "../../../apiRequestCache";

const USER_COLORS = [
  "#3498db", "#e74c3c", "#2ecc71", "#f39c12",
  "#9b59b6", "#1abc9c", "#e67e22", "#34495e",
];

export const useJobTaskUsers = (apiUrl) => {
  const [jobUsersTask, setJobUsersTask] = useState({});
  const [loadingUsersByJobTask, setLoadingUsersByJobTask] = useState({});

  const fetchJobTaskUsers = useCallback(
    async (jobId) => {
      if (jobUsersTask[jobId] || loadingUsersByJobTask[jobId]) return;
      setLoadingUsersByJobTask((prev) => ({ ...prev, [jobId]: true }));
      try {
        const data = await dedupeFetch(`${apiUrl}/api/Permissions/users-by-job-with-task/${jobId}`);
        const users = data.users || [];
        const formattedUsers = users.map((user, index) => ({
          id: user.userId,
          name: user.fullName || user.userName,
          username: user.userName,
          initials: getInitials(user.fullName || user.userName),
          color: USER_COLORS[index % USER_COLORS.length],
          accessLevel: user.accessLevel,
          assignedAt: user.assignedAt,
          ...user,
        }));
        setJobUsersTask((prev) => ({ ...prev, [jobId]: formattedUsers }));
      } catch (error) {
        console.error(`Error fetching task users for job ${jobId}:`, error);
        toast.error(`Failed to load task users for job`);
      } finally {
        setLoadingUsersByJobTask((prev) => ({ ...prev, [jobId]: false }));
      }
    },
    [apiUrl, jobUsersTask, loadingUsersByJobTask]
  );

  return { jobUsersTask, loadingUsersByJobTask, fetchJobTaskUsers };
};